import React from 'react';
import { styled } from '@goodrx/matisse';

const StyledTypingIndicator = styled.div`
  @keyframes blink {
    50% {
      opacity: 1;
    }
  }

  @keyframes bulge {
    50% {
      transform: scale(1.02);
    }
  }

  background-color: #e6e7ed;
  will-change: transform;
  width: auto;
  border-radius: 50px;
  padding: 12px;
  display: table;
  align-self: flex-start;
  position: relative;
  animation: 2s bulge infinite ease-out;

  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: -2px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #e6e7ed;
  }

  &::after {
    height: 10px;
    width: 10px;
    left: -10px;
    bottom: -10px;
  }

  span {
    height: 8px;
    width: 8px;
    float: left;
    margin: 0 2px;
    background-color: #9e9ea1;
    display: block;
    border-radius: 50%;
    opacity: 0.4;

    &:nth-of-type(1) {
      animation: 1s blink infinite calc(1 * 0.3333s);
    }

    &:nth-of-type(2) {
      animation: 1s blink infinite calc(2 * 0.3333s);
    }

    &:nth-of-type(3) {
      animation: 1s blink infinite calc(3 * 0.3333s);
    }
  }
`;

export const TypingIndicator = React.forwardRef<any>((_, ref) => (
  <StyledTypingIndicator ref={ref}>
    <span />
    <span />
    <span />
  </StyledTypingIndicator>
));
